import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 10px 20px 10px;
  width: calc(100% - 20px);
`;

export const Button = styled.button`
  width: 140px;
  height: 30px;
  margin: 0 15px;
  padding: 0 10px;
  align-items: center;
  color: ${(props) =>
    props.selected ? props.theme.colors.white : props.theme.colors.label};
  background: ${(props) =>
    props.selected ? props.theme.colors.darkblue : props.theme.colors.card};
  transition: background-color 0.3s;
  border-radius: 10px;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 20px);
  margin: 10px 10px;
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 30px);
  height: 25px;
  margin: 8px 15px;
  padding: 3px 12px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 12px;
  color: ${(props) => props.theme.colors.white};
  background: ${(props) => props.background};

  label {
    text-transform: uppercase;
  }

  div {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
`;

export const Label = styled.label`
  font-size: ${(props) => props.size};
  color: ${(props) => props.color};
  font-weight: bold;
  margin: ${(props) => props.margin};
`;

export const FooterContainer = styled.div`
  display: flex;
  width: calc(100% - 50px);
  margin: 0 15px;
  align-items: center;
  justify-content: space-between;
`;
